import { makeStyles } from "@material-ui/core/styles";
export const DiasCalendarioStyle = makeStyles((theme) => ({
  dias: {
    fontSize: "2vh",
    fontFamily: "Montserrat",
    fontWeight: "bold",
  },
  diasNoMes: {
    fontSize: "2vh",
    fontFamily: "Montserrat",
    color: "gray",
  },
}));
